import { SelectComponent } from './select.component';

export default angular
  .module('sfMobile.components.input-select', [])
  .component('sfSelect', SelectComponent).name;
